import { BroadcastChannel } from 'broadcast-channel';

export type TeamCanvasLockBroadcastType = 'holder_acquired' | 'holder_released';

export interface TeamCanvasLockBroadcastMessage {
  type: TeamCanvasLockBroadcastType;
  roomId: string;
  tabId: string;
}

type TeamCanvasLockBroadcastListener = (message: TeamCanvasLockBroadcastMessage) => void;

let channel: BroadcastChannel<TeamCanvasLockBroadcastMessage> | null = null;
const listeners = new Set<TeamCanvasLockBroadcastListener>();

/**
 * 确保画布锁跨页签 BroadcastChannel 已初始化。
 */
function ensureChannel() {
  if (typeof window === 'undefined') {
    return null;
  }
  if (!channel) {
    channel = new BroadcastChannel<TeamCanvasLockBroadcastMessage>('roboneo-team-canvas-lock');
    channel.addEventListener('message', (data: TeamCanvasLockBroadcastMessage) => {
      listeners.forEach((listener) => listener(data));
    });
  }
  return channel;
}

/**
 * 监听同浏览器其他页签的持锁 / 释放消息。
 */
export function addTeamCanvasLockBroadcastListener(listener: TeamCanvasLockBroadcastListener) {
  ensureChannel();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * 广播当前页签持锁或释放事件（同浏览器内协调，服务端仍以 tab_id 为准）。
 */
export function broadcastTeamCanvasLock(message: TeamCanvasLockBroadcastMessage) {
  const activeChannel = ensureChannel();
  activeChannel?.postMessage(message);
}
